import { CaretRight, SealPercent } from "@phosphor-icons/react";
import { Icon } from "@shopflo/ui/icon";
import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { useLocale } from "lib/hooks/useLocale";
import React from "react";
import { ViewOtherCouponsTileProps } from "../couponProps";
import PartnerOffersStrip from "./PartnerOffersStrip";

const ViewOtherCouponsTile: React.FC<ViewOtherCouponsTileProps> = ({
  setCouponApplyError,
  availableCoupons,
  customisations,
  onOpenPartnerOffers,
  onOpen,
  partnerOffersConfig,
}) => {
  const {
    state: { coupons },
    actions: { setCheckoutModal },
  } = useCheckoutContext();
  const { t } = useLocale();

  return (
    <>
      <div
        className="flex py-2 justify-between w-full items-center px-3"
        onClick={() => {
          onOpen?.();
          setCheckoutModal("DISCOUNT_LIST");
          setCouponApplyError?.({ status: false, message: "" });
        }}>
        <div
          className="text-text-xs-medium flex gap-1.5 items-center"
          style={{ color: customisations?.footer?.primaryColor }}>
          <Icon
            IconComponent={SealPercent}
            size="xs"
            iconProps={{
              color: customisations?.footer?.primaryColor,
              weight: "fill",
            }}
          />
          {coupons?.length > 1 ? (
            <span>{t("coupons_length", { count: coupons?.length - 1 })}</span>
          ) : (
            <p>{t("more_offers")}</p>
          )}
        </div>
        <p
          className="text-text-xs-medium flex items-center gap-1.5"
          style={{ color: customisations?.footer?.infoColor }}>
          {(availableCoupons?.shopflo ?? 0) + (availableCoupons?.shopify ?? 0)
            ? t("view_all_coupons")
            : t("enter_a_coupon_code")}
          <div className="flex h-3.5 w-3.5 items-center justify-center">
            <Icon
              IconComponent={CaretRight}
              size="xxxs"
              className="text-zinc-700/60"
              iconProps={{ weight: "bold", color: customisations?.footer?.infoColor }}
            />
          </div>
        </p>
      </div>
      <PartnerOffersStrip
        showDivider
        customisations={customisations}
        onOpenPartnerOffers={onOpenPartnerOffers}
        partnerOffersConfig={partnerOffersConfig}
      />
    </>
  );
};

export default ViewOtherCouponsTile;
